<section class="acfs" [class.acfs--overlap]="overlap">
  <div class="acfs-inner pt-3 pt-xl-5">
    <div class="acfs-copy">
      <h1 class="acfs-title">
        <span class="acfs-title-line1">
          ประชาสัมพันธ์
          <span class="acfs-mascot" aria-hidden="true">
            <img src="/ui/images/qjung-pr1.png" alt="" class="acfs-mascot-img">
          </span>
        </span>
        <span class="acfs-title-line2">
          <span class="acfs-title-serif-gold">มาตรฐาน</span><span class="acfs-title-serif-green">สินค้าเกษตร</span>
        </span>
      </h1>
      <p class="acfs-subtitle">
        รวบรวมเพจประชาสัมพันธ์สินค้าเกษตรที่ผ่านการรับรองมาตรฐานคุณภาพ
        ค้นหาตามชื่อสินค้า และรหัสมาตรฐาน
      </p>
    </div>

    <div class="search-card-wrap">
      <div class="search-card">
        <div class="search-row">
          <div class="search-input-wrap">
            <svg class="search-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="7.5" cy="7.5" r="5.5"/><line x1="11.5" y1="11.5" x2="16" y2="16"/></svg>
            <input
              type="text"
              class="search-input"
              [ngModel]="searchQuery"
              (ngModelChange)="onQueryInput($event)"
              (keyup.enter)="onSearch()"
              placeholder="ค้นหาชื่อเพจ ชื่อสินค้า หรือคำสำคัญ">
          </div>
          <button class="btn-search" (click)="onSearch()">ค้นหา</button>
        </div>
        @if (showSort) {
          <div class="sort-row">
            <span class="sort-label">เรียงตาม</span>
            <div class="sort-pill-group">
              @for (mode of sortModes; track mode.value) {
                <button
                  class="sort-pill"
                  [class.sort-pill--active]="sortBy === mode.value"
                  (click)="onSortMode(mode.value)">
                  {{ mode.label }}
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
